import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAppSelector } from 'ReduxStore/hooks';
import {
    TOP_BAR_TOTAL_HEIGHT,
    MINIMISED_OFFSET,
    TOP_BAR_ITEMS_HEIGHT,
    TOP_BAR_HEIGHT
} from '../../../../runtime/Navigation/Menu/Menu.styles';

const EpgWrapper = ({ children }) => {
    const isMinimised = useAppSelector((state) => state.webMenu.isMinimised);
    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                marginTop: isMinimised ? TOP_BAR_HEIGHT : TOP_BAR_TOTAL_HEIGHT,
                transition: 'margin .16s linear'
            }}
        >
            {children}
        </div>
    );
};

EpgWrapper.defaultProps = {
    children: []
};

EpgWrapper.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default EpgWrapper;
